export enum InquiriesAndDataAnalyticsTabs {
  Inquiries,
  DataAnalytics,
}

type TabProps = {
  id: string;
  "aria-controls": string;
};

export const getTabProps = (tab: InquiriesAndDataAnalyticsTabs): TabProps => ({
  id: `module-tab-${tab}`,
  "aria-controls": `module-tabpanel-${tab}`,
});

type Tab = {
  id: InquiriesAndDataAnalyticsTabs;
  label: string;
};

export const tabs: Tab[] = [
  { id: InquiriesAndDataAnalyticsTabs.Inquiries, label: "1:1 Inquiries" },
  { id: InquiriesAndDataAnalyticsTabs.DataAnalytics, label: "Data Analytics" },
];
